import marked from 'marked'
import hanabi from 'hanabi'
// import xss from './xss'
import $ from './index'
import Emoji from '../plugins/emojis'

const renderer = new marked.Renderer()
renderer.code = (code, lang) => {

  const highlighted = !!(lang && hljs.getLanguage(lang))
    ? hljs.highlight(lang, code).value
    : $.escape(code);

  // Render the highlighted code with `hljs` class.
  return '<pre><code class="hljs language-'+lang+'">'+highlighted+'</code></pre>';
};

marked.setOptions({
    renderer: 'hljs' in window ? renderer : new marked.Renderer(),
    highlight(code, lang){return 'hljs' in window  ? (lang && hljs.getLanguage(lang) && hljs.highlight(lang, code, true).value || hljs.highlightAuto(code).value) : hanabi(code)},
    gfm: true,
    tables: true,
    breaks: true,
    pedantic: false,
    sanitize: true,
    smartLists: true,
    smartypants: true,
    headerPrefi: 'v-'
})

export default s=>{
    // return xss(Emoji.parse(marked(s)))
    return Emoji.parse(marked(s))
}
